import { authed } from './auth'

/** Значение за окно и за такое же окно перед ним. */
export interface Pair {
  now: number
  prev: number
}

export interface DashSeries {
  days: string[]
  accounts: number[]
  deleted_users: number[]
  new_users: number[]
  active: number[]
  messages_guild: number[]
  messages_dm: number[]
  voice_minutes: number[]
  stream_minutes: number[]
  peak_online: number[]
  new_guilds: number[]
  site_visits: number[]
  site_uniques: number[]
  register_opens: number[]
  signup_starts: number[]
}

export interface Dashboard {
  at: string
  range: { from: string; to: string; days: number }
  /** users — люди; боты отдельно (bots) и в остальные цифры страницы не входят. */
  totals: { users: number; bots: number; email_only: number; guilds: number; plus_active: number; boosts: number; reports_open: number }
  kpi: {
    new_users: Pair
    active: Pair
    dau: Pair
    messages: Pair
    voice_minutes: Pair
    stream_minutes: Pair
    peak_online: Pair
    new_guilds: Pair
    site_visits: Pair
    signup_starts: Pair
  }
  profiles: { equipped: number; frames: number; effects: number; plates: number; names: number; themes: number; showcases: number; tags: number; reward_owners: number }
  achievements: { people: number; period_people: number; period_earned: number; rows: { id: string; name: string; earned: number; period: number; progressing: number }[] }
  series: DashSeries
  funnel: {
    registered: number
    joined_server: number
    wrote: number
    voice: number
    d1_eligible: number
    d1: number
    w1_eligible: number
    w1: number
  }
  cohorts: { week: string; size: number; active: number[] }[]
  top_guilds: { id: string; name: string; icon: string | null; messages: number; members: number }[]
  sources: { code: string; signups: number }[]
}

export interface Live {
  at: string
  online: number
  in_voice: number
  streaming: number
  active_today: number
  new_today: number
  /** Не зависят от выбранного периода; необязательны для старых API при выкладке. */
  totals?: Dashboard['totals']
  peak_today?: number
  new_guilds_today?: number
  peak_boosts_today?: number
}

/** Чем человек заходил за период: приложение для компьютера, браузер на компьютере, телефон. */
export interface PeopleClient {
  kind: 'app' | 'browser' | 'phone'
  os: string
}

export interface PeopleServer {
  id: string
  name: string
  icon: string | null
  owner_id: string
  created_at: string
  listed: boolean
  members: number
  messages: number
  writers: number
}

export interface PeoplePerson {
  id: string
  username: string
  name: string
  avatar: string | null
  created_at: string
  last_active: string | null
  servers: string[]
  messages: number
  clients: PeopleClient[]
  /** Своей ссылкой за всё время: сколько пришло и сколько из них начали общаться. */
  invited: number
  invited_active: number
}

/** Пришедшие по реферальной ссылке; кто кого привёл, сервер не отдаёт. */
export interface PeopleInvites {
  total: number
  active: number
  /** зарегистрировались по ссылке за период */
  period: number
  /** все регистрации за период */
  signups: number
  /** сколько людей привели хоть кого-то */
  inviters: number
}

/**
 * Личные связи без имён: узлы 0…nodes−1, чей какой — не сказано. Друзья — [a, b],
 * переписка — [a, b, сообщений], звонки — [a, b, звонков, принятых].
 */
export interface PeopleLinks {
  nodes: number
  friends: [number, number][]
  dms: [number, number, number][]
  calls: [number, number, number, number][]
  groups: { chats: number; people: number }
  call_totals: { calls: number; answered: number; minutes: number }
}

export interface PeopleStats {
  at: string
  range: { from: string; to: string; days: number }
  servers: PeopleServer[]
  people: PeoplePerson[]
  links: PeopleLinks
  invites: PeopleInvites
}

export type StatsPeriod = number | { from: string; to: string }
function periodQuery(period: StatsPeriod): string {
  return typeof period === 'number' ? `days=${period}` : new URLSearchParams(period).toString()
}
export const statsApi = {
  dashboard: (period: StatsPeriod) => authed<Dashboard>(`/moderation/stats/dashboard?${periodQuery(period)}`),
  live: () => authed<Live>('/moderation/stats/live'),
  people: (period: StatsPeriod) => authed<PeopleStats>(`/moderation/stats/people?${periodQuery(period)}`),
}
